import { createSlice } from "@reduxjs/toolkit";
import { getDealFromId } from "./actions";

const initialState = {
  loading: false,
  hasErrors: false,
  deal: null,
};

const dealSlice = createSlice({
  name: "deals",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getDealFromId.pending, state => {
      state.loading = true;
    });
    builder.addCase(getDealFromId.fulfilled, (state, { payload }) => {
      state.hasErrors = false;
      state.loading = false;
      state.deal = payload;
    });
    builder.addCase(getDealFromId.rejected, state => {
      state.hasErrors = true;
      state.loading = false;
    });
  },
});

export default dealSlice.reducer;
